import React from "react";
import { View, TouchableOpacity, StyleSheet, Pressable } from "react-native";
import ModalComponent from "../ModalComponent";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import dimensions from "../../globalStyles/dimensions";
import CustomComponent from "../../components/CustomComponent";
import OnBoardingIcons from "../../assets/Icons/OnBoardingIcons";
import ProfileIcons from "../../assets/Icons/FeedIcons/ProfileIcons";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";

interface DifferentMethodProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  onPress: any;
}
export default function OnboardingUploadModal({
  isDialog = false,
  isVisible,
  toggleModal,
  onPress,
}: {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  onPress: any;
}) {
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View
        style={{
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Background layer color
          width: "100%",
          height: "100%",
          position: "absolute",
          alignItems: "center",
        }}
      >
        <View style={styles.modalWrap}>
        <View 
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <CustomComponent.TextView
              title={"Find a photo or video"}
              textStyle={GlobalStyles.heading3}
              boxStyle={{
                paddingVertical: 10,
              }}
            />
            <Pressable onPress={toggleModal}>
                <ExperienceIcons.Cross/>
            </Pressable>
          </View>
          {/* <View style={styles.modalBox}>
            <View style={styles.modelCircle}>
              <OnBoardingIcons.FacebookIcon />
            </View>
            <CustomComponent.TextView
              title={"Facebook"}
              textStyle={GlobalStyles.bodyText}
            />
          </View> */}
          {/* <View style={styles.modalBox}>
            <View style={styles.modelCircle}>
              <OnBoardingIcons.InstagramIcon />
            </View>
            <CustomComponent.TextView
              title={"Instagarm"}
              textStyle={GlobalStyles.bodyText}
            />
          </View> */}
          <TouchableOpacity style={styles.modalBox} onPress={onPress}>
            <View style={styles.modelCircle}>
              <ProfileIcons.UploadArrow />
            </View>
            <CustomComponent.TextView
              title={"Upload from gallery"}
              textStyle={GlobalStyles.bodyText}
            />
          </TouchableOpacity>
        </View>
      </View>
    </ModalComponent>
  );
}

const styles = StyleSheet.create({
  centeredView: {
    width: 328,
    borderRadius: 8,
    paddingHorizontal: dimensions.paddingHorizontal,
    paddingVertical: dimensions.paddingVertical / 2,
    justifyContent: "center",
    overflow: "hidden",
    backgroundColor: Colors.white000,
    elevation: 2,
  },
  modalWrap: {
    backgroundColor: "white",
    width: "92%",
    padding:10,
    paddingHorizontal:20,
    overflow: "hidden",
    borderRadius: 8,
  },
  modalBox: {
    width: dimensions.windowWidth,
    display: "flex",
    flexDirection: "row",
    paddingVertical: 8,
    alignItems: "center",
  },
  modelCircle: {
    borderWidth: 0.5,
    height: 34,
    width: 34,
    borderRadius: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 14,
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
  },
});
